'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import globalStore from '../Global';

class DeviceConfigStore {
  @observable listPageTotal = 1;
  @observable currentPage = 1;

  @observable configList = [];

  @observable copyModalStatus = false;
  @observable copyModalData = {};

  @action.bound
  loadConfigList(page) {
    globalStore.loadingStatus = true;
    globalStore.loadingTip = '正在加载中...';
    let param = buildUrl({
      page_num: page,
      page_size: 10
    });
    fetch(`/api/config${param}`, { method: 'GET' }, json => {
      this.configList = json.content;
      this.listPageTotal = json.total;
      globalStore.loadingStatus = false;
      globalStore.loadingTip = '';
      this.currentPage = page;
    });
  }

  @action.bound
  changePage(page) {
    this.currentPage = page;
    this.loadConfigList(page);
  }

  @action.bound
  showCopyModal(data) {
    this.copyModalStatus = true;
    this.copyModalData = data;
  }

  @action.bound
  hideCopyModal(form) {
    this.copyModalStatus = false;
    this.copyModalData = {};
    form && form.resetFields();
  }

  @action
  postConfiguration(data) {
    return fetch(`/api/config`, { method: 'POST', body: data }, json => json);
  }
}
export default new DeviceConfigStore();



// WEBPACK FOOTER //
// ./src/store/DeviceConfig/DeviceConfig.js